<template lang="pug">
.pano-video
  .content.pos-r.fl(
    v-loading='loading'
    element-loading-text='视频加载中...'
    element-loading-spinner='el-icon-loading')

    #panovideoBody.video-body(ref='videoConHook')

    .video-bar.pos-a
      .video-progress.pos-a(ref='proBarHook')
        .progress-box.hand(v-if='isPC' @mousedown='handleForwardX')
          .box-pass.pos-a(:style='widthStyle')
          .box-circle.pos-a(ref='proBarCtrl', @mousedown='handleDownX')
        .progress-box.hand(v-else @touchstart='handleForwardX')
          .box-pass.pos-a(:style='widthStyle')
          .box-circle.pos-a.active(ref='proBarCtrl', @touchstart='handleDownX')

      .video-ctrl.pos-a.clearfix
        .video-ctrl-item.fl
          span.play.hand(@click.prevent='togglePlay')
            i.iconfont(:class='getPlayStatus ? "icon-pause" : "icon-play"')
          span.time {{ getCurTime | formatTime }}/{{ getTotalTime | formatTime }}

        .video-ctrl-item.pos-a.tools-wrap
          tools(:menu='toolsMenu')
</template>

<script>
import { getDomPos, isPC } from '@/utils'
import { NEXT_VIDEO, CHANGE_SCENE } from '@/config/contant'
import { mapGetters, mapActions } from 'vuex'

import AUTH from '@/utils/cookie'
import tools from '@/components/tools'
import hotspotMixin from '@/mixins/hotspot'
// import panoVideoMixin from '@/mixins/panovideo'

export default {
  name: 'panoVideo',
  mixins: [hotspotMixin],
  components: { tools },
  data() {
    return {
      isPC: isPC(),
      krpano: null,
      loading: false,
      currentSceneId: null,
      currentSceneUrl: null,
      curTime: 0,
      totalTime: 0,
      proBarObj: {
        bar: null,
        ctrl: null,
        line: null,
      }, // 进度条
      widthStyle: {
        width: '5px',
      },
      drag: {
        downX: 0,
        isDrag: false,
      },
      isMuted: false,
      isPlay: false,
      isEnd: false,
      timer2: null,
      volTimer: null,
    }
  },
  created() {
    // 获取视频完整信息
    this.fetchVideoInfo(this.$route.query.videoid).then(res => {
      // 密码访问
      const panokey = AUTH.getCookie('panokey')
      if (!panokey && !!res.ispass) {
        this.$router.push('/premission')
      }
    })
    this.toolsMenu = this.$CONFIG.toolsMenu
  },
  mounted() {
    window.onvideo_onloaded = () => {
      this.isPlay = false
      var krpano = document.getElementById('krpanoSWFObject')
      this.krpano = krpano
      this.$krp.initKrplugin(this.krpano)
    }

    window.onvideo_ready = () => {
      this.krpanoReady()
    }

    window.onvideo_complete = () => {
      this.handleEnd()
    }

    window.onvideo_updatetime = (curTime, totalTime) => {}

    window.onvideo_startvr = () => {}

    window.onvideo_playpause = () => {}

    this.$nextTick(() => {
      this.getDom()
      this.emitChangeScene()
      this.initEmbedPano()
    })
  },
  computed: {
    ...mapGetters([
      'isFullSceen',
      'isShowLogin',
      'getVideoSceneList',
      'getVideoHotspots',
    ]),
    getCurTime() {
      return this.curTime
    },
    getTotalTime() {
      return this.totalTime
    },
    getPlayStatus() {
      return this.isPlay
    },
  },
  methods: {
    ...mapActions({
      fetchVideoInfo: 'VIDEO_DATA',
      fetchVideoHotspots: 'VIDEO_SCENE_HOTSPOTS',
    }),
    emitChangeScene() {
      this.$vgo.on(CHANGE_SCENE, ({ sceneId, url }) => {
        this.currentSceneId = sceneId
        this.currentSceneUrl = url
        this.replay()
      })
    },
    initEmbedPano() {
      window.embedpano({
        swf: window.$globalconfig.URLS.API + this.$CONFIG.SWF,
        xml:
          window.$globalconfig.URLS.API +
          this.$CONFIG.XML +
          '?video_id=' +
          this.$route.query.videoid,
        target: 'panovideoBody',
        html5: 'prefer',
        mobilescale: 1.0,
        passQueryParameters: true,
      })
    },
    krpanoReady() {
      const initTotalTime = () => {
        const total = this.$krp.getVideoTotalTime()
        let timeid = null
        if (total) {
          this.curTime = this.$krp.getVideoTime()
          this.totalTime = this.$krp.getVideoTotalTime()
          this.loading = false

          if (!this.currentSceneId) {
            // 加载首个视频的热点
            const firstScene = this.getVideoSceneList[0]
            this.fetchVideoHotspots(firstScene.scene_id)
          }
          this.play()
          clearTimeout(timeid)
        } else {
          timeid = setTimeout(() => {
            initTotalTime()
          }, 1000)
        }
      }
      initTotalTime()
    },
    resetProgress() {
      this.widthStyle.width = '5px'
    },
    replay() {
      this.resetProgress()
      this.$krp.changeVideo(this.currentSceneId, this.currentSceneUrl)
    },
    play() {
      console.log('play')
      this.getDom()
      this.$krp.playVideo()
      this.timer = setInterval(() => {
        const curTime = this.getVideoTime()
        this.changeBarPos(curTime / this.totalTime)
        this.curTime = curTime
      }, 50)
      this.isPlay = true

      this.showTimelineHotspot()
      this.timer2 = setInterval(() => {
        this.showTimelineHotspot()
      }, 1000)
    },
    pause() {
      this.$krp.pauseVideo()
      this.isPlay = false
      clearInterval(this.timer)
      clearInterval(this.timer2)
    },
    togglePlay() {
      if (this.isEnd) {
        this.proBarObj.ctrl.style.left = '0'
      }
      this.isPlay ? this.pause() : this.play()
    },
    toggleVolume() {
      if (isPC()) {
        this.isMuted ? this.setVolMuted(100) : this.setVolMuted(0)
        this.volNum = this.isMuted ? 100 : 0
      }
      this.isMuted = !this.isMuted
    },
    showTimelineHotspot() {
      let hostspots = this.getVideoHotspots
      hostspots.forEach(point => {
        if (
          this.$krp.getVideoTime() >= point.starttime &&
          this.$krp.getVideoTime() <= point.endtime
        ) {
          this.$krp.showVideoHotspot(point.hot_id)
        } else {
          this.$krp.hideVideoHotspot(point.hot_id)
        }
      })
    },
    // showCurTimeHotspot (stime, etime) {
    //   let hostspots = this.getVideoHotspots

    //   hostspots.forEach((point) => {
    //     if (etime <= point.endtime && stime >= point.starttime) {
    //       this.$krp.showVideoHotspot(point.hot_id)
    //     } else {
    //       this.$krp.hideVideoHotspot(point.hot_id)
    //     }
    //   })
    // },
    handleEnd() {
      // this.isEnd = true
      // this.isPlay = false
      this.setVideoTime(0)
      this.widthStyle.width = '5px'
      clearInterval(this.timer)
      clearInterval(this.timer2)
      this.$vgo.emit(NEXT_VIDEO)
    },
    getVideoTime() {
      return this.$krp.getVideoTime()
    },
    setVideoTime(time) {
      this.$krp.setVideoTime(time)
    },
    resizeVideoTime() {
      this.setVideoTime(0)
      this.proBarObj.ctrl.style.left = 0
    },
    setVolMuted(val) {
      this.$krp.setVideoVolume(val / 100)
    },
    mutedVol() {
      this.setVolMuted(0)
      this.isMuted = true
    },
    getPos(obj) {
      return getDomPos(obj)
    },
    // 拖拽进度条
    handleDownX(ev) {
      ev.preventDefault()
      ev = ev || window.event
      let cx = ev.clientX
      if (!this.isPC && ev.targetTouches && ev.targetTouches[0]) {
        cx = ev.targetTouches[0].clientX
      }
      let { left } = this.getPos(this.proBarObj.line)

      this.drag.downX = cx - left - this.proBarObj.ctrl.offsetLeft
      this.drag.isDrag = true

      let apiUp = 'ontouchend'
      let apiMove = 'ontouchmove'
      if (isPC()) {
        apiUp = 'onmouseup'
        apiMove = 'onmousemove'
      }
      window[apiMove] = ev => {
        this.handleMoveX(ev)
      }
      window[apiUp] = () => {
        window[apiMove] = null
        window[apiUp] = null
        this.drag.isDrag = false
      }
    },
    handleMoveX(ev) {
      ev = ev || window.event
      let cx = ev.clientX
      if (!this.isPC && ev.targetTouches && ev.targetTouches[0]) {
        cx = ev.targetTouches[0].clientX
      }
      let proBar = this.proBarObj.bar
      let oCtrl = this.proBarObj.ctrl
      let { left } = this.getPos(this.proBarObj.line)

      if (this.drag.isDrag) {
        let l = cx - left - this.drag.downX
        if (l < 0) {
          l = 0
        } else if (l >= proBar.offsetWidth - oCtrl.offsetWidth) {
          l = proBar.offsetWidth - oCtrl.offsetWidth
        }

        let scale = Number(l / (proBar.offsetWidth - oCtrl.offsetWidth))

        this.changeBarPos(scale)
        this.curTime = Number(this.$krp.getVideoTime()).toFixed(2)
        this.setVideoTime(scale * this.totalTime)
      }
    },
    // 点击进度条控制视频时间
    handleForwardX(ev) {
      ev.preventDefault()
      ev = ev || window.event
      let cx = ev.clientX
      if (!this.isPC && ev.targetTouches && ev.targetTouches[0]) {
        cx = ev.targetTouches[0].clientX
      }
      let proBar = this.proBarObj.bar
      let oCtrl = this.proBarObj.ctrl
      let { left } = this.getPos(proBar)
      let l = cx - left - 6

      let scale = Number(l / (proBar.offsetWidth - oCtrl.offsetWidth))

      this.changeBarPos(scale)
      this.curTime = Number(this.$krp.getVideoTime()).toFixed(2)
      this.setVideoTime(scale * this.totalTime)
    },
    // 修改控制按钮位置
    changeBarPos(scale) {
      let val = scale * this.proBarObj.bar.offsetWidth + 6 + 'px'
      this.proBarObj.ctrl.style.left = val
      this.widthStyle.width = val
    },
    getDom() {
      this.proBarObj = {
        bar: this.$refs.proBarHook,
        ctrl: this.$refs.proBarCtrl,
        line: this.$refs.proBarLine,
      }
    },
  },
  watch: {
    isFullSceen(b) {
      this.$krp.setVideoFullScreen()
    },
    isShowLogin(val) {
      val ? this.pause() : this.play()
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~assets/styles/mixins.styl'
@import '~assets/styles/colors.styl'
@import '~assets/styles/variables.styl'
$paddingWidth = 0

.pano-video
  height: 100%
  .content
    height: 100%
    width: 100%
    box-sizing: border-box
    background-color: $--background-color
  .image-timeline
    top: 20%
    left: $paddingWidth
    right: $paddingWidth
    padding: 10px
    background-color: rgba($--color-black, .5)
    z-index: 10
    .img-box
      float: left
      width: 40px
      height: 40px
  .video-body
    width: 100%
    height: 100%
  .video-bar
    $--padding-width = 0
    bottom: 0
    left: $--padding-width
    right: $--padding-width
    width: 100%
    height: 2.8125rem
    box-sizing: border-box
    background: -webkit-linear-gradient(bottom, rgba(0, 0, 0, .6) 15%, rgba(0, 0, 0, 0))
    transition: transform .2s ease
    z-index: 10

    .video-progress
      $progress-height = 4px
      $bar-active-color = #f00
      top: -4px
      width: 100%
      height: $progress-height
      &:hover
        .progress-box .box-circle
          display: block
          transform: scale(1.1)
      .progress-timeline
        margin-top: -30px
        padding: 0 20px
        box-sizing: border-box
        .label
          flex: 0 0 60px
          width: 60px
          line-height: 40px
          font-size: 14px
          text-shadow: 0 0 8px #000
          color: $--color-white
        .el-slider
          flex: 1

      .progress-box
        $bar-color = $--color-blue
        margin: auto
        width: 100%
        height: $progress-height
        background-color: rgba($--color-white, .2)
        border-radius: 8px

        .box-pass
          left: 0
          width: 100%
          height: 100%
          background-color: rgba($bar-color, .8)
        .box-circle
          left: 0
          top: -3px
          width: $progress-height * 2
          height: $progress-height * 2
          border-radius: 100%
          background-color: rgba($bar-color, .8)
          // transition: all .4s
          display: none
          &.active
            display: block !important
            transform: scale(1.5) !important
    .video-ctrl
      $barHright = 2.8125rem
      display: flex
      width: 100%
      height: 100%
      .video-ctrl-item
        height: $barHright
        line-height: $barHright - 5px
        padding: 0 5px
        i
          font-size: 1.5rem
          color: $--color-white
        .play, .time
          display: inline-block
          padding: 0 2px
          box-sizing: border-box
        .play
          height: 45px
          i
            position: relative
            top: 2px
            color: $--color-white
        .time
          height: $barHright
          line-height: 40px
          font-size: 16px
          box-sizing: border-box
          color: $--color-white

.theme-b
  .tools-wrap
    right: 0
    .voice-wrap
      top: -100px

@media (min-width: 768px)
  .muted
    padding: 0 10px
    .muted-wrap
      left: 120%
      top: 50%
      transform: translateY(-50%)
      width: 100px

@media (min-width: 375px) and (max-width: 414px)
  .muted
    padding: 0 10px
    z-index: 10
    .muted-wrap
      top: -230%
      left: 0
  .play
    i
      font-size: 20px
@media (max-width: 320px)
  .pano-video
    .video-bar
      .video-ctrl
        .video-ctrl-item
          & > span
            padding: 0 5px
          .play i
            font-size: 20px
          .time
            font-size: 15px
</style>
